var _span;
import clsx from 'clsx';
import * as React from 'react';
import * as Styled from './Anchor.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Anchor = /*#__PURE__*/React.forwardRef(function Anchor({
  as = 'a',
  variant = 'primary',
  disabled = false,
  external,
  children,
  onClick,
  target,
  className,
  ...props
}, ref) {
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsxs(Styled.Anchor, {
      ref: ref,
      variant: variant,
      as: as,
      "aria-disabled": disabled || undefined,
      target: external && !target ? '_blank' : target,
      onClick: event => disabled ? event.preventDefault() : onClick == null ? void 0 : onClick(event),
      className: clsx('ovpn-anchor', `${variant}-anchor`, `anchor-as-${as}`, className),
      ...props,
      children: [children, (external || props.target === '_blank') && (_span || (_span = /*#__PURE__*/_jsx("span", {
        className: "ovpn-anchor-external-sign",
        children: /*#__PURE__*/_jsx(Styled.ExternalIcon, {})
      })))]
    })
  );
});
export default Anchor;